// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".progress[data-v-270ae781] {\n  height: 8px;\n}\n.progress-bar[data-v-270ae781] {\n  height: 8px;\n  background-color: #412dcd;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
